export default __webpack_public_path__ + "static/media/web-app.489ea617.svg";